import { Component, OnInit, Input, TemplateRef, ViewChild, Output, EventEmitter } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { DecimalPipe } from '@angular/common';
import { SwiperConfigInterface, SwiperDirective, SwiperPaginationInterface } from 'ngx-swiper-wrapper';
import { MatDialog } from '@angular/material/dialog';
import { ProductDialogComponent } from './product-dialog/product-dialog.component';
import { Settings, AppSettings } from 'src/app/app.settings';
import { ApiService } from '../services/api.service';
import { PaginationInstance } from 'ngx-pagination';

@Component({
  selector: 'app-products-carousel',
  templateUrl: './products-carousel.component.html',
  styleUrls: ['./products-carousel.component.scss']
})
export class ProductsCarouselComponent implements OnInit {
  @Input() products: any;
  @Input() featuredCount: any;
  @Input() newArrivalCount: any;
  @Input() paginationDetails: any;

  categories: any;
  @Input() store: any;
  productDialogRef;
  private pagination: SwiperPaginationInterface = {
    el: '.swiper-pagination',
    clickable: true,
    hideOnClick: false,
    // type: 'bullets',
    // dynamicBullets: true,
    // dynamicMainBullets: 5,
    // renderCustom:  (swiper, current, total) => {
    //   return current + ' of ' + total;
    // },
    // renderBullet:  (index, className) => {
    //   return '<span class="' + className + '">' + (index + 1) + '</span>';
    // }
  };
  @ViewChild('productDialog', { static: true }) productDialog: TemplateRef<any>;
  @ViewChild(SwiperDirective, { static: false }) directiveRef: SwiperDirective;
  public config: SwiperConfigInterface = {};
  public productConfig: SwiperConfigInterface = {};
  public settings: Settings;
  featuredLength;
  newArrivalLength;
  FeatureTagProbadgeImgFit: boolean = false;
  featureTags = {} ;
  public productTabs = [];
  public productDescription;
  public count: number = 10;
  isFeatureTagShowTwoLineDescription: boolean = false;
  constructor(
    public appSettings: AppSettings,
    public dialog: MatDialog,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private apiService: ApiService) {
    this.settings = this.appSettings.settings;
  }

  ngOnInit() {
    this.featureTags = JSON.parse(sessionStorage.getItem("featureTags"));
    this.FeatureTagProbadgeImgFit = !!this.featureTags && this.featureTags['sf_product_badges_issues'] ? true : false ;
    this.featuredLength = this.products['type'] === 'featured' ? this.products.length : this.newArrivalLength = this.products.length;
    this.isFeatureTagShowTwoLineDescription = !!this.featureTags && this.featureTags['ftag_sf_show_two_line_description_in_product_card'] ? true : false;
    if(!!this.featureTags && this.featureTags['ftag_shop_home_is_randomly_blank_fix']){
      const swiperContainer = document.querySelector('.swiper-container');
      if (swiperContainer) {
        if (this.featuredCount && this.featuredCount <= 3) {
          swiperContainer.classList.add('swiper-no-swiping');
        }
        if (this.newArrivalCount && this.newArrivalCount <= 3) {
          swiperContainer.classList.add('swiper-no-swiping');
        }
      } else {
        console.warn('swiper-container not found in DOM at ngOnInit');
      }
    }else{
      if (this.featuredCount && this.featuredCount <= 3) {
        document.querySelector('.swiper-container').classList.add('swiper-no-swiping');
      }
      if (this.newArrivalCount && this.newArrivalCount <= 3) {
        document.querySelector('.swiper-container').classList.add('swiper-no-swiping');
      }
    }
  }

  ngAfterViewInit() {
    this.productConfig = {
      slidesPerView: 1,
      spaceBetween: 0,
      keyboard: true,
      navigation: true,
      pagination: false,
      grabCursor: true,
      loop: false,
      preloadImages: false,
      lazy: true,
      effect: "fade",
      fadeEffect: {
        crossFade: true
      }
    }
    this.config = {
      observer: true,
      direction: 'horizontal',
      slidesPerView: 6,
      spaceBetween: 16,
      keyboard: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: false,
      grabCursor: false,
      loop: false,
      preloadImages: false,
      lazy: true,
      // preventClicks: false,
      // preventClicksPropagation: false,
      breakpoints: {
        480: {
          slidesPerView: 1
        },
        740: {
          slidesPerView: 2,
        },
        960: {
          slidesPerView: 3,
        },
        1280: {
          slidesPerView: 3,
        },
        1500: {
          slidesPerView: 3,
        },
        1700: {
          slidesPerView: 4,
        },
        1920: {
          slidesPerView: 4,
        }
      },

    }
  }

  public openProductDialog(product) {
    product['storeDetails'] = this.store;
    this.productTabs = [];
    // product['images'] = [{medium: product['product']['product_image1']}]
    // if(!!product['product']['product_image2'] && product['product']['product_image2'] !== "null") {
    //   product['images'][1] = {medium: product['product']['product_image2']};
    // }
    
    // if ( this.featureTags && this.featureTags['supplier_details_tab_product_page']) {
      // // Product Description 
      const parser = new DOMParser();
      // const doc = parser.parseFromString(product['product']['website_description'], 'text/html');
      // if (doc){
      //   var HtmlDiv = doc.querySelector('[role="tabpanel"]');
      //   HtmlDiv ? HtmlDiv.remove() : "";
      //   product['product']['website_description'] = doc.body.textContent ? doc.body.textContent : "";
      // }
      // Product Description 
      const doc2 = parser.parseFromString(product['product']['website_description'], 'text/html');
      const doc = parser.parseFromString(product['product']['website_description'], 'text/html');
      if (doc){
        doc.querySelectorAll('[role="tab"]').forEach(tabheader => {
        var Tabid=tabheader.getAttribute('aria-controls');
            this.productTabs.push({
              'header' : tabheader.innerHTML,
              'Tabid' : Tabid
            })
        }); 
        if(this.productTabs.length>0){
          this.productTabs.forEach((tabbody, key) => { 
            var TabContent=doc.getElementById(tabbody.Tabid.toString()).innerHTML;
            this.productTabs[key]['TabContent']=TabContent;
          });
          var HtmlDiv = doc2.querySelector('[role="tabpanel"]');
          HtmlDiv.remove();
        }
        this.productDescription = doc2.body.textContent ? doc2.body.textContent : "";
      }
    // }

    product['images'] = !!product['product']['product_image1'] && !!product['product']['product_image2'] ? [{ medium: product['product']['product_image1'] }, { medium: product['product']['product_image2'] }] :
      !!product['product']['product_image1'] && !!product['product']['product_image2'] === false ? [{ medium: product['product']['product_image1'] }] :
        !!product['product']['product_image1'] === false && !!product['product']['product_image2'] ? [{ medium: product['product']['product_image2'] }] : [{ medium: '' }];
        if (!!this.featureTags && this.featureTags['pdp_button_color_change']) {
          this.productDialogRef = this.dialog.open(this.productDialog, {
            minWidth: '80vw',
            data: product,
            panelClass: 'product-dialog-quick-view',
            direction: (this.settings.rtl) ? 'rtl' : 'ltr'
          });
        }else{
          this.productDialogRef = this.dialog.open(this.productDialog, {
            minWidth: '80vw',
            data: product,
            panelClass: 'product-dialog',
            direction: (this.settings.rtl) ? 'rtl' : 'ltr'
          });
        }
    // this.productDialogRef.afterClosed().subscribe(productValue => {
    //   if(productValue){
    //     this.router.navigate(['/products', product.id, product.name]); 
    //   }
    // });
  }
  close(): void {
    this.productDialogRef.close();
  }
  goToProduct(product, value) {
    var description = product['product']['description'].replace('&amp;', '&');
    var parentCategory = this.products.categories.find(val => val['category_url'] === product['product']['cb_category']['url']);
    if (!!parentCategory === false) {
      var parent = this.products.categories.find(val => {
        return val['sub_list'].some(sub => {
          return sub['category_url'] === product['product']['cb_category']['url']
        });
      });
      if (!!parent) {
        if (product['product']['website_url']) {
          // this.router.navigate(['/categories', parent['category_url'], product['product']['cb_category']['url'], product['product']['website_url']]);
          this.router.navigate(['/products', product['product']['website_url']]);
        } else {
          // this.router.navigate(['/categories', parent['category_url'], product['product']['cb_category']['url'], product['product']['id']]);
          this.router.navigate(['/products', product['product']['id']]);
        }
      } else {
        if(product['product']['website_url']){
        // this.router.navigate(['/categories', parent['category_url'], product['product']['cb_category']['url'], product['product']['website_url']]);
        this.router.navigate(['/products', product['product']['website_url']]);
        }else{
        // this.router.navigate(['/categories', parent['category_url'], product['product']['cb_category']['url'], product['product']['id']]);
        this.router.navigate(['/products', product['product']['id']]);
        }
        if(product['product']['website_url']){
          // this.router.navigate(['/categories', product['product']['cb_category']['url'],product['product']['website_url']]);
          this.router.navigate(['/products', product['product']['website_url']]);
        }else{
        // this.router.navigate(['/categories', product['product']['cb_category']['url'],product['product']['id']]);
        this.router.navigate(['/products', product['product']['id']]);
        }
      }

    } else {
      if(product['product']['website_url']){
        // this.router.navigate(['/categories', product['product']['cb_category']['url'], product['product']['website_url']]);
        this.router.navigate(['/products', product['product']['website_url']]);
      }else{
      // this.router.navigate(['/categories', product['product']['cb_category']['url'], product['product']['id']]);
      this.router.navigate(['/products', product['product']['id']]);

      }
    }

  }

  getRouterLink(product: any): any[] {
    if (product['product']['website_url']) {
      return ['/products', product['product']['website_url']];
    } else {
      return ['/products', product['product']['id']];
    }
  }
  generateHref(product: any): string {    
      const urlTree = this.router.createUrlTree(this.getRouterLink(product));
      return this.router.serializeUrl(urlTree);
  }




}